<div
  class="cv-review-ui"
  *ngIf="!showForm && !showSuccess && !showATS"
>
  <!---------------------- Main UI for the CV Review ---------------------------->
  <!-- Chance of Hiring -->
  <div class="cv-review-main">
    <div class="hire-chance row">
      <div class="col-lg-6 col-12">
        <h1>Increase Your Chance Of Getting Hired</h1>
        <img
          class="mobile-img"
          src="../../../../assets/images/get-hired.webp"
          alt="get hired"
        />
        <p>
          Get Quality CV Review and Revamp By Our Expert Recruiters At
          Affordable Fee
        </p>
        <button (click)="toggleFormUI()">Get 50% OFF</button>
      </div>
      <div class="col-lg-1 col-0"></div>
      <div class="col-lg-5 col-12">
        <img
          class="web-img"
          src="../../../../assets/images/get-hired.webp"
          alt="get hired"
        />
      </div>
    </div>
    <!-- Cost of CV Review -->
    <div class="cost-of-review row">
      <div class="col-lg-6 col-12">
        <img
          src="../../../../assets/images/cv-cost.webp"
          alt="cv cost"
        />
      </div>
      <div class="col-lg-6 col-12 cost-of-review-text">
        <h3>Start Free, No Upfront Charges</h3>
        <p>
          No Upfront Payment, Upload your CV for Free we only charge you when we
          are sure we can help
        </p>
        <h2>What You Get at Just <span>N7,500</span></h2>
        <ul class="custom-list">
          <li *ngFor="let item of list_benefits">
            <div class="list-div">
              <img
                [src]="item.photo"
                alt="list icon"
              />
              <h6>{{ item.text }}</h6>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <!-- Some of the success story -->
    <div class="success-story">
      <h2>Some of Our Success Stories</h2>
      <div class="card-container">
        <div
          class="card"
          *ngFor="let item of feedback_card"
        >
          <h6>{{ item.text }}</h6>
          <div class="company-name">
            <h4 class="initial">{{ extractFirstLetter(item.naam) }}</h4>
            <div>
              <p class="p-naam">{{ item.naam }}</p>
              <p class="p-comp">{{ item.company }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 50% Discount -->
    <div class="discount">
      <h2>Don't Miss Out – 50% Discount Ends Soon!</h2>
      <p>
        A small investment in your CV can be the turning point in your job
        search. Whether you're applying for your first role or your fiftieth, a
        professionally reviewed CV gives you a real edge.
      </p>
      <div class="money-imgs">
        <img
          src="../../../../assets/images/cancel-amount.webp"
          alt="cancel"
        />
        <img
          src="../../../../assets/images/discount-amount.webp"
          alt="discount"
        />
      </div>
      <div class="text-center">
        <button (click)="toggleFormUI()">Claim Offer Now</button>
      </div>
    </div>
  </div>
</div>
<!-- CV Review Upload Form -->
<div
  class="cv-review-ui-2"
  *ngIf="showForm && !showATS && !showSuccess"
>
  <div class="upload-cv-text">
    <h3>Tell us about you</h3>
    <p>
      Our aim is to gain a deeper understanding of your professional background,
      which will enable us to customize your resume to match your desired job
      positions more effectively.
    </p>
    <div class="radio-group">
      <label class="custom-radio">
        <input
          type="radio"
          name="option"
          [(ngModel)]="selectedOption"
          value="haveCV"
        />
        I currently have a CV
      </label>

      <label class="custom-radio">
        <input
          type="radio"
          name="option"
          [(ngModel)]="selectedOption"
          value="notHaveCV"
        />
        I do not have a CV
      </label>
    </div>
  </div>
  <div
    *ngIf="selectedOption === 'haveCV'"
    class="upload-cv"
  >
    <p>Upload current CV</p>
    <div class="upload-section">
      <!-- UPLOAD CV ROW -->
      <div class="row cv-upload-section">
        <div class="col-lg-4">
          <label class="custom-file-upload">
            <input
              type="file"
              (change)="onFileSelected($event)"
              accept=".pdf"
            />
            <img
              src="../../../../assets/images/browse-arrow.png"
              alt="browse"
            />
            Browse computer
          </label>
        </div>
        <div class="col-lg-6 progress-bar-container p-0">
          <mat-progress-bar
            mode="determinate"
            [value]="file.progress"
          ></mat-progress-bar>
          <p class="uploaded-file-name">{{ file.name }}</p>
          <button
            *ngIf="file.progress > 0"
            (click)="removeFile()"
            class="btn-remove"
          >
            &#10006;
          </button>
        </div>
        <div class="col-lg-2"></div>
      </div>
      <!-- ADD THE EMAIL AND PHONE -->
      <form [formGroup]="withCVForm">
        <div class="row mt-3 form-row">
          <div class="col-lg-6 col-12 form-group">
            <label>Email</label>
            <input
              type="email"
              class="form-control"
              id=""
              aria-describedby=""
              placeholder=""
              required="required"
              formControlName="email"
              [pattern]="emailPattern"
            />
            <div *ngIf="f.email.touched && f.email.invalid">
              <span
                class="text-left text-danger pb-1"
                *ngIf="f.email.errors.required"
                >Email is required</span
              >
              <span
                class="text-left text-danger pb-1"
                *ngIf="f.email.errors?.pattern"
                >Email is not valid.</span
              >
            </div>
          </div>
          <div class="col-lg-6 col-12 form-group">
            <label>Phone Number</label>
            <input
              type="text"
              class="form-control"
              id=""
              aria-describedby=""
              placeholder=""
              required="required"
              formControlName="phoneNumber"
              [pattern]="numberPattern"
            />
            <div *ngIf="f.phoneNumber.touched && f.phoneNumber.invalid">
              <span
                class="text-left text-danger pb-1"
                *ngIf="f.phoneNumber.errors.required"
                >Number is required</span
              >
              <span
                class="text-left text-danger pb-1"
                *ngIf="f.phoneNumber.errors?.pattern"
                >Number is not valid</span
              >
            </div>
          </div>
        </div>
        <div class="btn-div">
          <button (click)="submitCV()">Continue</button>
        </div>
      </form>
    </div>
  </div>
  <!-- Without adding CV Form -->

  <div
    class="cv-review-separator"
    *ngIf="selectedOption === 'notHaveCV'"
  ></div>

  <div
    class="without-cv"
    *ngIf="selectedOption === 'notHaveCV'"
  >
    <p class="without-cv-title">No CV? No PROBLEM!</p>

    <p class="without-cv-description">
      Our CV Builder will guide you through the process of building a proper
      professional CV. Then you can request our professional review. Login below
      if you already have an account or Signup if you are new
    </p>

    <div
      class="without-cv-btns"
      *ngIf="!isLoggedIn"
    >
      <button
        class="without-cv-login"
        (click)="withoutCVLogin()"
        type="button"
      >
        LOGIN
      </button>

      <button
        class="without-cv-signup"
        (click)="withoutCVSignUp()"
        type="button"
      >
        SIGNUP
      </button>
    </div>

    <div
      class="without-cv-btns"
      *ngIf="isLoggedIn"
    >
      <button
        class="without-cv-signup"
        (click)="continueToCVBuilder()"
        type="button"
      >
        CONTINUE TO CV BUILDER
      </button>
    </div>
    <!--
    <form
      [formGroup]="withoutCVForm"
      class="form-class"
    >
     // FULL NAME
      <label>Full Name</label>
      <input
        type="text"
        class="form-control"
        aria-describedby=""
        placeholder=""
        required="required"
        formControlName="fullName"
        [pattern]="namePattern"
      />
      <div *ngIf="f2.fullName.touched && f2.fullName.invalid">
        <span
          class="text-left text-danger pb-1"
          *ngIf="f2.fullName.errors.required"
          >Name is required</span
        >
        <span
          class="text-left text-danger pb-1"
          *ngIf="f2.fullName.errors?.pattern"
          >Name is not valid.</span
        >
      </div>
      <// ADD THE EMAIL AND PHONE
      <div class="row mt-3 form-row">
        <div class="col-lg-5 col-12 form-group">
          <label>Email</label>
          <input
            type="email"
            class="form-control"
            id=""
            aria-describedby=""
            placeholder=""
            required="required"
            formControlName="email"
            [pattern]="emailPattern"
          />
          <div *ngIf="f2.email.touched && f.email.invalid">
            <span
              class="text-left text-danger pb-1"
              *ngIf="f2.email.errors.required"
              >Email is required</span
            >
            <span
              class="text-left text-danger pb-1"
              *ngIf="f2.email.errors?.pattern"
              >Email is not valid.</span
            >
          </div>
        </div>
        <div class="col-lg-2 col-0"></div>
        <div class="col-lg-5 col-12 form-group">
          <label>Phone Number</label>
          <input
            type="text"
            class="form-control"
            id=""
            aria-describedby=""
            placeholder=""
            required="required"
            formControlName="phoneNumber"
            [pattern]="numberPattern"
          />
          <div *ngIf="f2.phoneNumber.touched && f2.phoneNumber.invalid">
              class="text-left text-danger pb-1"
              *ngIf="f2.phoneNumber.errors.required"
              >Number is required</span
            >
            <span
              class="text-left text-danger pb-1"
              *ngIf="f2.phoneNumber.errors?.pattern"
              >Number is not valid</span
            >
          </div>
        </div>
      </div>
     // EXPERIENCE
      <label>Total years of experience</label>
      <div class="custom-dropdown">
        <select formControlName="experience">
          <option
            value=""
            disabled
            hidden
          >
            Experience
          </option>
          <option
            value="{{ exp }}"
            *ngFor="let exp of expLvl"
          >
            {{ exp }} year<span *ngIf="exp > 1">s</span>
          </option>
        </select>
        <img
          src="../../../../assets/images/arrow-down.webp"
          alt="dropdown icon"
          class="dropdown-icon"
        />
      </div>
      // EDUCATION
      <label>Total years of experience</label>
      <div class="custom-dropdown">
        <select formControlName="education">
          <option
            value=""
            disabled
            hidden
          >
            Education
          </option>
          <option
            value="{{ edu }}"
            *ngFor="let edu of education"
          >
            {{ edu }}
          </option>
        </select>
        <img
          src="../../../../assets/images/arrow-down.webp"
          alt="dropdown icon"
          class="dropdown-icon"
        />
      </div>
      <div class="btn-div-2">
        <button
          class="btn-back"
          (click)="goToCVoption()"
        >
          Back
        </button>
        <button
          class="btn-continue"
          (click)="withoutCV()"
        >
          Continue
        </button>
      </div>
    </form>
  --></div>
</div>

<div
  class="cv-review-ui-4"
  *ngIf="!showForm && showATS && !showSuccess"
>
  <div class="row">
    <div class="col-lg-7">
      <h1>
        Hi, {{ geminiRefinedCV.firstName }} {{ geminiRefinedCV.lastName }}
      </h1>
      <p class="para-1">
        We’ve completed a detailed analysis of your current CV and have
        identified the strong points you should keep building on, as well as
        the areas that need improvement to stand out to employers
      </p>
      <h5>YOUR ATS SCORE IS : {{ geminiSuggestions.ATS_Score }}</h5>

      <h4>High Points</h4>
      <ul class="high-points">
        <li *ngFor="let point of geminiSuggestions.High_points">{{ point }}</li>
      </ul>

      <h4>Low Points</h4>
      <ul class="low-points">
        <li *ngFor="let point of geminiSuggestions.Low_points">{{ point }}</li>
      </ul>

      <!-- <h4>Recommendations</h4>
      <ul>
        <li *ngFor="let point of geminiSuggestions.Recommendations">{{ point }}</li>
      </ul> -->

      <p class="para-2">
        We’ve also created a <b>fully revamped</b> and
        <b>optimized</b> version of your CV, complete with
        <b>expert recommendations</b> for just <b>N5,000</b>
      </p>
      <button (click)="goToCvSeletor()">Preview Fully Revamp CV</button>
    </div>
    <div class="col-lg-5 ats-img">
      <img
        class="resume-img"
        src="../../../../assets/images/resume-image.webp"
        alt="resume"
      />
    </div>
  </div>
</div>

<div
  class="cv-review-ui-3"
  *ngIf="!showForm && !showATS && showSuccess"
>
  <img
    src="../../../../assets/images/colored-envelope.webp"
    alt="envelope"
  />
  <h1>Thank You</h1>
  <p>
    We have received your information. A member of our team will contact you
    before 24 hours.
  </p>
</div>
